export default function urlToBase64(url: string): string {
  const utf8Bytes = new TextEncoder().encode(url);

  let binaryString = "";
  utf8Bytes.forEach((byte) => {
    binaryString += String.fromCharCode(byte);
  });

  return btoa(binaryString);
}
